import { render } from "./Sorting.vue?vue&type=template&id=4a23408a"
import script from "./Sorting.vue?vue&type=script&lang=js"
export * from "./Sorting.vue?vue&type=script&lang=js"
script.render = render

export default script